// old AIzaSyCGaEyI_sKWR3Qs1mLx7BuoZ4tm9z2kLrA
// new AIzaSyBYXGgP9EqCxAC_o9ZcooeWz7XxWQ4Yhy4
export const MAP = 'AIzaSyBYXGgP9EqCxAC_o9ZcooeWz7XxWQ4Yhy4';
